import { connect, FormikValues } from 'formik'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { FormLabel } from '@/components/StyledComponents'
import { StyledDateTimePicker } from '@/pages/SpaceAppBuilder/components/StyledComponents'

import messages from './messages'
import { isValidStartDateOption } from './ScheduledTrigger'

type OneTimeProps = {
  readOnly?: boolean
}

const StyledSpan = styled.span`
  color: #ff0000;
  margin-right: 5px;
`

function OneTime({ formik, readOnly = false }: OneTimeProps & FormikValues) {
  const intl = useIntl()

  const { values, setFieldValue } = formik
  return (
    <>
      <FormLabel>
        <StyledSpan>{intl.formatMessage(messages.required)}</StyledSpan>
        {intl.formatMessage(messages.scheduleFor)}
      </FormLabel>
      <StyledDateTimePicker
        readOnly={readOnly}
        name="triggerData.date"
        // @ts-expect-error
        isValid={value => isValidStartDateOption(value)}
        showIcon={true}
        value={values.triggerData.date}
        placeholderText={intl.formatMessage(messages.pleaseSelectDateTime)}
        onChange={setFieldValue}
        includeTime={true}
        showTime={true}
      />
    </>
  )
}

export default connect(OneTime)
